import PreviousIconSvg from "static/images/previous-icon.svg";
import NextIconSvg from "static/images/next-icon.svg";

interface Props {
  variant: "previous" | "next";
  tooltip?: string;
  onClick?: () => void;
  isDisabled?: boolean;
}

export default function PreviousOrNextButton(props: Props) {
  const { variant, tooltip, isDisabled, onClick } = props;

  const getCssClasses = () => {
    return `border-1.5 border-promGray2 shadow-customMin rounded p-2 w-8 h-7.5 flex justify-center ${
      isDisabled ? "bg-promGray3" : "cursor-pointer hover:bg-promWhite1"
    }`;
  };

  return (
    <div
      className={getCssClasses()}
      onClick={() => (!isDisabled ? onClick?.() : () => {})}
    >
      <img
        src={variant === "previous" ? PreviousIconSvg : NextIconSvg}
        alt={variant}
        title={tooltip}
        className="text-primaryRed"
      />
    </div>
  );
}
